import { Range } from 'slate';

export function isCollapsed(selection) {
  return !!selection && Range.isCollapsed(selection);
}
